import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./guards/authGuardService";

const routes: Routes = [
  {
    path: "accessRole",
    loadChildren: () =>
      import("./pages/accessRole/accessRole.module").then(
        (m) => m.AccessRoleModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "user",
    loadChildren: () =>
      import("./pages/user/user.module").then((m) => m.UserModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "tenantUser",
    loadChildren: () =>
      import("./pages/tenantUser/tenantUser.module").then(
        (m) => m.TenantUserModule
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: "profile",
    loadChildren: () =>
      import("./pages/profile/profile.module").then((m) => m.ProfileModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "customer",
    loadChildren: () =>
      import("./pages/customer/customer.module").then((m) => m.CustomerModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "withdrawal",
    loadChildren: () =>
      import("./pages/withdrawal/withdrawal.module").then(
        (m) => m.WithdrawalModule
      ),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: 'creditAdjustment',
  //   loadChildren: () => import('./pages/creditAdjustment/creditAdjustment.module').then((m) => m.CreditAdjustmentModule),
  //   canActivate: [AuthGuardService],
  // },

  {
    path: "forgetPassword",
    loadChildren: () =>
      import("./pages/forgetPassword/forgetPassword.module").then(
        (m) => m.ForgetPasswordModule
      ),
  },

  // START HERE
  {
    path: "tenant",
    loadChildren: () =>
      import("./pages/tenant/tenant.module").then((m) => m.TenantModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "outlet",
    loadChildren: () =>
      import("./pages/outlet/outlet.module").then((m) => m.OutletModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "report",
    loadChildren: () =>
      import("./pages/report/report.module").then((m) => m.ReportModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "notification",
    loadChildren: () =>
      import("./pages/notification/notification.module").then(
        (m) => m.NotificationModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "happening",
    loadChildren: () =>
      import("./pages/happening/happening.module").then(
        (m) => m.HappeningModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "faq",
    loadChildren: () =>
      import("./pages/faq/faq.module").then((m) => m.FaqModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "portion",
    loadChildren: () =>
      import("./pages/portion/portion.module").then((m) => m.PortionModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "sales",
    loadChildren: () =>
      import("./pages/sales/sales.module").then((m) => m.SalesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "setting",
    loadChildren: () =>
      import("./pages/setting/setting.module").then((m) => m.SettingModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "ent",
    loadChildren: () =>
      import("./pages/ent/ent.module").then((m) => m.EntModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "topup",
    loadChildren: () =>
      import("./pages/topup/topup.module").then((m) => m.TopupModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "itemPricing",
    loadChildren: () =>
      import("./pages/itemPricing/itemPricing.module").then(
        (m) => m.ItemPricingModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "transaction",
    loadChildren: () =>
      import("./pages/transaction/transaction.module").then(
        (m) => m.TransactionModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "item",
    loadChildren: () =>
      import("./pages/item/item.module").then((m) => m.ItemModule),
    canActivate: [AuthGuardService],
  },
  {
    path: "customerVoucher",
    loadChildren: () =>
      import("./pages/customerVoucher/customerVoucher.module").then(
        (m) => m.CustomerVoucherModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "accountRemoval",
    loadChildren: () =>
      import("./pages/accountRemoval/accountRemoval.module").then(
        (m) => m.AccountRemovalModule
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
